/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MinimalProductDto } from '../../models/minimal-product-dto';
import { ProductTypeEnum } from '../../models/product-type-enum';

export interface ProductAddNew$Plain$Params {
  productType?: ProductTypeEnum;
}

export function productAddNew$Plain(http: HttpClient, rootUrl: string, params?: ProductAddNew$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<MinimalProductDto>> {
  const rb = new RequestBuilder(rootUrl, productAddNew$Plain.PATH, 'post');
  if (params) {
    rb.query('productType', params.productType, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MinimalProductDto>;
    })
  );
}

productAddNew$Plain.PATH = '/api/Product/new';
